import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: "[pcg-ng-pagination]",
    templateUrl: "./pagination.component.html",
    host: {
        "area-label": "Pagination bar"
    }
})
export class PaginationComponent {

    @Input()
    public control: FormControl = new FormControl<number>(1);
    @Input()
    public parentSelector: string = "";

    public readonly GAP: number = 3;

    public totalPages: number = 1;

    @Input("totalPages")
    public set pagingSetter(value: number) {
        if (value === undefined || value === null) {
            return;
        }

        this.totalPages = value;
    }

    @Output()
    public onPageClick = new EventEmitter();

    public setPage(pageNumber: number): void {
        this.control.setValue(pageNumber);
        this.onPageClick.emit();
    }

    public getMiddleNumbers(start: number, end: number): Array<number> {
        start = start <= 0 ? 1 : start;
        const length = end > this.totalPages ? this.totalPages : end;
        const numbers = new Array<number>();
        for (let pageNumber = start; pageNumber <= length; pageNumber++) {
            numbers.push(pageNumber);
        }

        return numbers;
    }

    public getFullNumbers(): Array<number> {
        const numbers = new Array<number>();
        for (let pageNumber = 1; pageNumber <= this.totalPages; pageNumber++) {
            numbers.push(pageNumber);
        }

        return numbers;
    }
}
